// removed by extract-text-webpack-plugin
module.exports = {"menu-dropdown-button":"menu-dropdown-button","menuDropdownButton":"menu-dropdown-button","menu-dropdown-button-text":"menu-dropdown-button-text","menuDropdownButtonText":"menu-dropdown-button-text","menu-item-text":"menu-item-text","menuItemText":"menu-item-text"};


//////////////////
// WEBPACK FOOTER
// ./src/components/portal/controls/menuDropdown/style.scss
// module id = 600
// module chunks = 0